const GoogleAdwordsProductCard = (productID: number, productName: string, productPrice: string) => {
  if (window?.ga && typeof window.ga === 'function') {
    window.ga('require', 'ec', 'ec.js');
    window.ga('ec:addProduct', {
      id: productID,
      name: productName,
      category: 'product',
      price: productPrice
    });
    window.ga('ec:setAction', 'detail');
  }
};
export default GoogleAdwordsProductCard;